import React from 'react';
import {
  EmptyState, EmptyStateContent, EmptyStateSize, EmptyStateSurfaceIcon,
} from '@bingads-webui-fluent-component/empty-state';
import { I18n } from '../types';

const NoSelectionsMessage = ({ i18n }: { i18n: I18n }) => (
  <EmptyState size={EmptyStateSize.mediumSurface}>
    <EmptyStateContent
      title={i18n.getString(_TL_('You haven’t selected anything yet.'))}
      subtext={i18n.getString(_TL_('Once you make selections, you’ll see them here.'))}
    >
      <EmptyStateSurfaceIcon />
    </EmptyStateContent>
  </EmptyState>
);

export default NoSelectionsMessage;
